<template>
	<div id="condition" v-if="menus[2]" v-html="menus[2].menuText">
		投稿要求
	</div>

	<!-- <div data-v-077fa876="" id="condition" class="view">
		<h2
			style="margin-top: 17px; margin-bottom: 17px; break-after: avoid; text-align: center; line-height: 36.6933px; font-family: Arial; font-size: 21px; text-wrap: wrap;">
			1111<span
				style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 36px;"><strong>“星火计划”投稿要求</strong></span>
		</h2>
		<h3>项目征稿</h3>
		<br>
		<p>
			<b>1）征稿领域</b>
			<br>
			<br>乳腺肿瘤、胃肠肿瘤、胸部肿瘤、妇科肿瘤、淋巴肿瘤
		</p>
		<br>
		<p>
			<b>2）征稿规模</b>
			<br>
			<br>五个领域，每个领域预计征集2000份初审合格作品，总计10000份作品。每位参与者投稿数量上限为4份。
		</p>
		<br>
		<p>
			<b>3）参与人员</b>
			<br>
			<br>医疗卫生机构肿瘤领域相关执业医师、药师、护师均可参与。
		</p>
		<br>
		<p>
			<b>4）内容方向</b>
			<br>
			<br>肿瘤防治三级预防（早发现、早诊断、早治疗）和肿瘤防治五大手段（防-筛-诊-治-康）的科普宣传
			<br>科学防癌主题：如常见肿瘤危险信号、日常防癌（健康生活方式可降低肿瘤风险、健康饮食有助于肿瘤防治、肿瘤与心理关系等）、防癌误区（肿瘤与遗传关系、肿瘤是否会传染、肿瘤治疗方式解读等）、肿瘤进入慢病化管理等科普知识
			<br>防癌筛查及体检主题：如高发肿瘤的早筛方法、防癌体检途径、家庭康复等
			<br>中医药抗癌相关主题：如中医药预防肿瘤、中西医结合防治癌症等
			<br>肿瘤医学人文主题：如音乐走近肿瘤、肿瘤患者的独白、诊断期/诊疗期/临终期人文关怀等
		</p>
		<br>
		<p>
			<b>5）征稿体裁</b>
			<br>
			<br>图文（word或PDF格式）、视频（不限格式）
		</p>
		<br>
		<p>
			<b>6）作品要求</b>
			<br>
			<br>图文作品：
			<br>字数不少于500字；
			<br>Word或PDF均可，不支持PPT；
			<br>使用汉语中文简体，题材不限，散文、诗歌、漫画均可；
			<br>要点突出、形式新颖、设计美观，具有较强的传播价值；
			<br>内容需有一定的专业性和科学医学教育价值。
			<br>
			<br>视频作品：
			<br>视频不低于2分钟；
			<br>可采用TED演讲、情景表演、微电影、公益广告、科普短片、动漫等形式进行创作，需配字幕；
			<br>普通话或方言讲解，内容陈述要求科学准确、重点突出；层次清楚、逻辑性强；通俗易懂、深入浅出。语言表达要求发音标准、吐字清晰;语言生动、语速适中；
			<br>输出格式为常规视频格式MPEG、MP4、AVI、MOV等；视频播放流畅，清晰度高，分辨率不低于1080P；如手机拍摄请用横屏格式，大小控制在50M以上。画面质量优，可供二次传播使用。
		</p>
		<br>
		<p>
			<b>7）投稿说明</b>
			<br>
			<br>支持个人或团体参与投稿，各参与团体及个人要对参与项目作品的原创性、科学性和真实性负责，严禁抄袭。
			<br>作品不得夹杂任何药品、平台、医院或科室等宣传推广内容。
			<br>项目专区不收取任何费用，所有报送作品一律不予退还。项目组委会享有参与项目作品的使用权，有权将参与项目作品用于本次活动相关宣传展示，且不向投稿者支付相关费用。
		</p>
	</div> -->

</template>

<script>
	import {
		ProjectPage // 优秀稿件
	} from '@/request/api';
	export default {
		name: 'condition',
		data() {
			return {
				menus: ''
			}
		},
		created() {
			this.getProjectPage();
		},
		mounted() {},
		methods: {
			getProjectPage() {
				ProjectPage().then(res => {
					if (res.code == 200) {
						this.menus = res.data.menus
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>
</style>